var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C4.5816 17 1 13.4184 1 9C1 4.5816 4.5816 1 9 1C13.4184 1 17 4.5816 17 9C17 13.4184 13.4184 17 9 17ZM9 15.4C10.6974 15.4 12.3253 14.7257 13.5255 13.5255C14.7257 12.3253 15.4 10.6974 15.4 9C15.4 7.30261 14.7257 5.67475 13.5255 4.47452C12.3253 3.27428 10.6974 2.6 9 2.6C7.30261 2.6 5.67475 3.27428 4.47452 4.47452C3.27428 5.67475 2.6 7.30261 2.6 9C2.6 10.6974 3.27428 12.3253 4.47452 13.5255C5.67475 14.7257 7.30261 15.4 9 15.4V15.4ZM9.8 9H13V10.6H8.2V5H9.8V9Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.47bf535bc21ecfc149f264658e034a66.svg";
export { ForwardRef as ReactComponent };